var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in"},[_c('div',[_c('EntryEditor',{attrs:{"module":_vm.module,"entry_id":_vm.entry_id},on:{"saved":_vm.saved,"deleted":_vm.deleted,"loaded":_vm.loaded}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }